import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InputWrapper from '../common/InputWrapper';
import Select from 'react-select';
import LocaleContext from 'constants/localization';
import { optionToValue, valueToOption } from 'helpers/objectHelpers';

const EnumEdit = (props) => {
  const LS = useContext(LocaleContext);
  const { options, field } = props;

  // Add empty option in the beginning if user wants to remove selected value
  if (options && options.length > 0 && options[0].value) {
    options.unshift({label: '\u2003'});
  }

  // Fits select component when display: flex (for multiple value remove button)
  const styles = {
    container: base => ({
      ...base,
      flex: 1
    })
  };

  const valueArray = field.values.length > 0 ? field.values : [null];

  const inputs = valueArray.map((value, key) => (
    <Select 
      key={key}
      styles={styles}
      options={options}
      value={valueToOption(value)}
      onChange={option => field.setValue(key, optionToValue(option))}
      placeholder={LS.actions.choose}
      isDisabled={field.disabled}
    />
  ));

  return <InputWrapper {...{...props, inputs}} />;
};

EnumEdit.propTypes = {
  field: PropTypes.object.isRequired,
  options: PropTypes.array,
};

const mapStateToProps = (state, props) => {
  const predicate = props.field.predicate;
  return {
    options: state.field.enums[predicate],
  };
};

export default connect(mapStateToProps, null)(EnumEdit);